import GbmRewards from "./gbm-rewards";

export default GbmRewards;